/* eslint-disable */
import React, { useState } from 'react';
import { DefaultTable } from 'src/components';
import { IDependentTable } from 'src/interfaces';
import { IDependent } from 'src/interfaces';
import { PersonalInfoForm } from '../..';
import { AlertAdapter, DataTableCellDeleteButton, DataTableCellEditButton } from 'pg-ui-library';
import { PersonalDependentsModal } from '../personal-dependents-modal';
import ConfirmationModal from 'src/components/confirmation-model';
import { useDeleteDependent } from '../../mutations/add-delete-update-dependent.mutation';
import { useActions } from 'src/hooks/useActions';

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
      font: 'normal normal bold 18px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 18px Biotif',
      color: '#1B1D35',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      fontWeight: 'SemiBold',
      justifyContent: 'left',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
    },
  },
  pagination: {
    style: {
      display: 'none',
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const DependentTable: React.FC<PersonalInfoForm> = ({ personalInfo }) => {
  const columns = [
    {
      name: 'First Name',
      selector: (row: IDependentTable) => row.firstName,
    },
    {
      name: 'Last Name',
      selector: (row: IDependentTable) => row.lastName,
    },
    {
      name: 'Home Phone',
      selector: (row: IDependentTable) => row.homePhone,
    },
    {
      name: 'Work Phone',
      selector: (row: IDependentTable) => row.workPhone,
    },
    {
      name: 'Relationship',
      selector: (row: IDependentTable) => row.relationship,
    },
    {
      name: 'Dependent',
      selector: (row: IDependentTable) => (row.isDependent ? 'Yes' : 'No') as 'Yes' | 'No',
    },
    {
      name: 'Actions',
      cell: (row: IDependentTable) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ cursor: 'pointer' }}>{editButtonWrapper(() => onEdit(row))}</div>
          <div style={{ cursor: 'pointer' }}>{deleteButtonWrapper(() => deleteDependent(row))}</div>
        </div>
      ),
    },
  ];
  const dependents = personalInfo?.dependents || [];
  const emergencyContacts = personalInfo?.emergencyContacts || [];
  const contacts = personalInfo?.contacts || [];
  const beneficiaries = personalInfo?.beneficiaries || [];

  const dependentIds = new Set(dependents.map(dependent => dependent.personId));

  const filteredEmergencyContacts = emergencyContacts.filter(
    emergencyContact => !dependentIds.has(emergencyContact.personId)
  );
  const filteredContacts = contacts.filter(contact => !dependentIds.has(contact.personId));
  const filteredBeneficiaries = beneficiaries.filter(beneficiary => !dependentIds.has(beneficiary.personId));

  let allContactslist = [...dependents, ...filteredEmergencyContacts, ...filteredContacts, ...filteredBeneficiaries];

  allContactslist = Array.from(new Map(allContactslist.map(contact => [contact.personId, contact])).values());

  const { getPersonalInfo } = useActions();
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(true);
  const [deleteDependentcheck, setDeleteDependentcheck] = useState<IDependent>();
  const deleteDependentMutation = useDeleteDependent();

  const [updateDependent, setUpdateDependent] = useState<IDependent | null>(null);

  const editButtonWrapper = (onClick: Function) => <DataTableCellEditButton onClick={() => onClick()} />;
  const deleteButtonWrapper = (onClick: Function) => <DataTableCellDeleteButton onClick={() => onClick()} />;

  const onEdit = (editDependent: IDependentTable) => {
    setIsOpen(!modalIsOpen);
    setIsUpdate(true);
    setUpdateDependent(editDependent);
  };

  const deleteDependent = (dependent: IDependentTable) => {
    if (dependent?.notAllowedEditionAndDelition) {
      AlertAdapter('This dependent is already included in an enrollment and cannot be deleted.', 'error');
      return;
    }
    setIsModalOpen(true);
    setDeleteDependentcheck(dependent);
  };

  const removeDependent = async () => {
    if (!deleteDependentcheck?.id) {
      return;
    }

    if (deleteDependentcheck) {
      try {
        await deleteDependentMutation.mutateAsync({ dependent: deleteDependentcheck });
        await getPersonalInfo();
      } catch (error) {
        console.error('Error deleting dependent:', error);
      }
    }
  };

  const handleConfirm = () => {
    removeDependent();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <PersonalDependentsModal
        updateDependent={updateDependent ? [updateDependent] : []}
        isOpen={modalIsOpen}
        setIsOpen={setIsOpen}
        isUpdate={isUpdate}
      />
      <ConfirmationModal
        isOpen={isModalOpen}
        message="Are you sure want to remove this Dependent?"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <DefaultTable columns={columns} data={(allContactslist as IDependentTable[]) ?? []} customStyles={customStyles} />
    </>
  );
};

export default DependentTable;
